/**
 * App-admin role model — the platform-level `user.role` from Better Auth's
 * admin plugin (distinct from the org-level `member.role` in `./roles.ts`).
 *
 * Two app-admin roles exist, ranked by privilege:
 * - `superadmin` — full platform admin, including storefront-wide settings
 *   (e.g. ASCPS Platform Settings).
 * - `admin` — every admin capability EXCEPT the superadmin-only surfaces.
 *
 * `superadmin` is a strict superset of `admin`: anywhere `admin` is granted
 * access, `superadmin` is too. Gate admin-or-better surfaces with
 * `isAppAdminRole`; gate superadmin-only surfaces with `isSuperAdminRole`.
 */

export const APP_ADMIN_ROLES = ['admin', 'superadmin'] as const
export type AppAdminRole = (typeof APP_ADMIN_ROLES)[number]

/** True for any app-admin role (`admin` or `superadmin`). */
export function isAppAdminRole(role: string | null | undefined): boolean {
  return role === 'admin' || role === 'superadmin'
}

/** True only for the `superadmin` role. */
export function isSuperAdminRole(role: string | null | undefined): boolean {
  return role === 'superadmin'
}
